import React from 'react';
const FieldLabel = (props) => {
  return (
    <label {...props}>{props.children}{ props.required ? <sup className="reqStar"> * </sup> :null}</label>
  )
}
export default FieldLabel
